// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Zo7d","title":"Info_title__1nPFe","selects":"Info_selects__3BaTK","requiredAsterisk":"Info_requiredAsterisk__WHmdg"};